import { render } from "./Spell.vue?vue&type=template&id=7bbcc6a2&scoped=true"
import script from "./Spell.vue?vue&type=script&lang=ts"
export * from "./Spell.vue?vue&type=script&lang=ts"

import "./Spell.vue?vue&type=style&index=0&id=7bbcc6a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7bbcc6a2"

export default script